import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { IReject, IResolve } from '@df/api/request/request.service';
import { routeOverride } from '@df/core/meta/route-override.pipe';
import { Customer } from '@df/session/api/customer';

@Injectable({
    providedIn: 'root'
})
export class CustomerNotLoggedGuard implements CanActivate {
    constructor(protected router: Router, private customer: Customer) {}

    canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
        return new Promise<boolean>((resolve: IResolve, reject: IReject) => {
            return this.customer.model
                .load()
                .then(() => {
                    if (this.isCustomerAllowed()) {
                        resolve(true);
                    } else {
                        if (!next.preventRedirect) {
                            this.onError();
                        }
                    }
                })
                .catch(reject);
        });
    }

    isCustomerAllowed(): boolean {
        return !this.customer.model.isLoggedIn;
    }

    onError(): void {
        this.router.navigateByUrl(routeOverride('/account'));
    }
}
